import {
  Component,
  inject,
  OnInit,
  ChangeDetectorRef,
  HostListener,
  ElementRef,
} from '@angular/core';
import { ProspectCard } from '../../components/prospect-card/prospect-card';
import { MatDialog } from '@angular/material/dialog';
import { Api } from '../../services/api';
import { MdlCall } from '../../components/mdl-call/mdl-call';
import { MdlTask } from '../../components/mdl-task/mdl-task';
import { MdlEvent } from '../../components/mdl-event/mdl-event';
import { MdlManageProspect } from '../../components/mdl-manage-prospect/mdl-manage-prospect';
import { CommonModule } from '@angular/common';
import { Mdlfilterectivities } from '../../components/mdl-filter-activities/mdl-filter-activities';
import { MdlChangeOwnerComponent } from '../../components/mdl-change-owner/mdl-change-owner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { ActivatedRoute, Router } from '@angular/router';
import { MdlConvertProspect } from '../../components/mdl-convert-prospect/mdl-convert-prospect';
import { MdlDelete } from '../../components/mdl-delete/mdl-delete';
import { PermissionService } from '../../services/permission.service';
import { Activities } from '../../components/activities/activities';
import { MdlNewTaskComponent } from '../../components/mdl-new-task/mdl-new-task';
import { MdlUpdateStatus } from '../../components/mdl-update-status/mdl-update-status';
import Swal from 'sweetalert2';
import { AlertService } from '../../services/alert.service';
import { FormsModule } from '@angular/forms';
import { MdlSendMail } from '../../components/mdl-send-mail/mdl-send-mail';
import { MdlNewEventComponent } from '../../components/mdl-new-event/mdl-new-event';

@Component({
  selector: 'app-prospect-detail',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatSelectModule,
    MatButtonModule,
    MatDividerModule,
    Activities,
    FormsModule,
  ],
  templateUrl: './prospect-detail.html',
  styleUrl: './prospect-detail.css',
})
export class ProspectDetail implements OnInit {
  public prospecto: any = {};
  public api = inject(Api);
  public menuOpen: boolean = false;
  public isLoading: boolean = true;
  public errorMessage: string = '';

  public proStatus: any = [];
  public proIndustries: any = [];

  public editInfo: boolean = false;
  public editDetails: boolean = false;
  public editableProspect: any = {};

  public showInfoSection: boolean = true;
  public showDetailsSection: boolean = true;
  public showHistorySection: boolean = true;

  readonly dialog = inject(MatDialog);

  openedMenuId: string | null = null;
  showRecentDropdown: boolean = false;

  public progreso_estado : any = [];

  public markedStatus: string = '';
  public prospecto_id: string = '';

  constructor(
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private elementRef: ElementRef,
    public permissionService: PermissionService,
    private router: Router,
    private alertService: AlertService
  ) {
    this.route.params.subscribe(params => {
      this.prospecto_id = params['id'];
      if (this.prospecto_id) {
        this.cargarProspecto(this.prospecto_id);
      } else {
        this.errorMessage = 'No se proporcionó un ID de prospecto válido';
        this.isLoading = false;
      }
    });
  }

  ngOnInit(): void {}

  cargarProspecto(id: string): void {
  this.api.showLoading();
  this.isLoading = true;
  this.errorMessage = '';

  this.api.getProspectById({ id }).subscribe({
    next: (data: any) => {
      this.prospecto = data.prospecto;
      this.progreso_estado = data.progreso_estados;
      this.isLoading = false;
      setTimeout(() => {
        this.api.hideLoading();
      }, 500);
    },
    error: (err: any) => {
      console.error("Error en API:", err);

      if (err.status === 403) {
        this.errorMessage = "No tienes permiso para ver este prospecto.";
        this.router.navigateByUrl("/prospects");

      } else {
        this.errorMessage = "Error al cargar el prospecto.";
      }

      this.isLoading = false;
      this.api.hideLoading();
    }
  });
}

  openManageProspect(prospecto: any): void {
    this.dialog.open(MdlManageProspect, {
      minWidth: '800px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        prospecto: this.prospecto,
        mode: 'edit'
      }
    }).afterClosed().subscribe((result) => {
    if (result) {

      this.cargarProspecto(this.prospecto.id);}
  });

    
  }

  openCreateProspect(): void {
    this.dialog.open(MdlManageProspect, {
      minWidth: '800px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        mode: 'create',
      },
    });
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
    this.cdr.detectChanges();
  }

  onOptionSelect(option: string) {
    console.log('Seleccionaste:', option);
    this.menuOpen = false;
    this.cdr.detectChanges();
  }

  openNewCall(): void {
    this.dialog.open(MdlNewTaskComponent, {
      minWidth: '650px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        entidad: this.prospecto,
        mode: 'call',
        tipo: 'PRO',
      },
    }).afterClosed().subscribe(result =>{
      if (result){
       window.location.reload() 
      }
    })
  }

  openNewTask(): void {
    this.dialog.open(MdlNewTaskComponent, {
      minWidth: '650px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        entidad: this.prospecto,
        mode: 'task',
        tipo:'PRO'
      },
    }).afterClosed().subscribe(result =>{
      if (result){
       window.location.reload() 
      }
    })
  }

  openNewEvent(): void {
    this.dialog.open(MdlNewEventComponent, {
      minWidth: '650px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        entidad: this.prospecto,
        mode: 'event',
        tipo:'PRO'
      },
    }).afterClosed().subscribe(result =>{
      if (result){
       window.location.reload() 
      }
    })
  }

  openNewfilterActivities(): void {
    this.dialog.open(Mdlfilterectivities, {
      minWidth: '650px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
    });
  }

  openNewChangeOwner(): void {
    console.log('Antes de abrir modal, prospecto:', this.prospecto);
    console.log('Prospecto que envío al modal:', this.prospecto);
    this.dialog
      .open(MdlChangeOwnerComponent, {
        minWidth: '750px',
        maxHeight: '900px',
        panelClass: 'mat-dlg-class',
        data: { prospectData: this.prospecto },
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          console.log('Nuevo propietario:', result);
        }
      });
  }

  openConvert(data: any) {
    this.dialog.open(MdlConvertProspect, {
      minWidth: '1050px',
      minHeight: '800px',
      maxHeight: '950px',
      panelClass: 'mat-dlg-class',
      data: {
        prospecto: data,
      },
    });
  }

  toggleActionsMenu(id: string): void {
    this.openedMenuId = this.openedMenuId === id ? null : id;
    this.showRecentDropdown = false;
  }

  openMdlDeleteProspect(id: string) {
    this.dialog.open(MdlDelete, {
      minWidth: '500px',
      minHeight: '260px',
      panelClass: 'mat-dlg-class',
      data: {
        mode: 'prospect',
        id: id,
      },
    });
  }

  markStatus(status: string){
    if (this.markedStatus === status) {
      this.markedStatus = '';
    } else {
      this.markedStatus = status;
    }
    console.log('Estado marcado:', this.markedStatus);
  }

  updateProspectoStatus(){
    const data = { prospecto_id: this.prospecto_id, id_estado: this.markedStatus};
    console.log('Datos para actualizar estado:', data);

    this.api.updateProspectStatus(data).subscribe({
      next: (data:any)=>{
        
        console.log(data);
        this.alertService.success('Exito','progreso actualizado exitosamente')
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      },
      error: (err: any) => {
                this.api.hideLoading();
        if (err?.status===403){
          this.alertService.error('Acceso denegado',"No tienes permiso para modificar prospectos.");
          return
        }
        this.alertService.error('Error','Ocurrió un problema al modificar el prospecto.')
      },
    });
  }

  openChangeStatus(p_status: string, e_status: string, status: string): void {
    if (p_status === e_status) {
      Swal.fire({
        position: 'top-end',
        title: 'Atención',
        text: 'El prospecto ya está asignado a este estado.',
        showConfirmButton: false,
        background: '#fcf67eff',
        timer: 5000,
        timerProgressBar: true,
        color: '#000000',
        backdrop: false,
      });
      return;
    }
    this.dialog.open(MdlUpdateStatus, {
      minWidth: '500px',
      maxHeight: '300px',
      panelClass: 'mat-dlg-class',
      data: {
        tipo: 'PRO',
        id_entidad: this.prospecto.id,
        status: status,
      },
    });
  }

  @HostListener('document:click', ['$event.target'])
  onClickOutside(target: EventTarget | null): void {
    if (!(target instanceof HTMLElement)) return;

    const clickedInsideRecent = this.elementRef.nativeElement
      .querySelector('.dropdown-trigger')
      ?.contains(target);
    const clickedInsideActions = this.elementRef.nativeElement
      .querySelector('.dots-button')
      ?.contains(target);

    if (!clickedInsideRecent) {
      this.showRecentDropdown = false;
    }

    if (!clickedInsideActions) {
      this.openedMenuId = null;
    }
  }

  toggleEdit(section: 'info' | 'details') {
    if (section === 'info') {
      this.editInfo = !this.editInfo;
    } else if (section === 'details') {
      this.editDetails = !this.editDetails;
    }

    if (this.editInfo || this.editDetails) {
      this.editableProspect = { ...this.prospecto };
    }
  }

  cancelEdit(section: 'info' | 'details') {
    if (section === 'info') this.editInfo = false;
    if (section === 'details') this.editDetails = false;
    this.editableProspect = { ...this.prospecto };
  }

  saveSection(section: 'info' | 'details') {
    this.api.updateProspect(this.editableProspect).subscribe({
      next: (resp: any) => {
        this.alertService.success('Éxito', 'Prospecto actualizado correctamente');

        this.prospecto = { ...this.editableProspect };

        if (section === 'info') this.editInfo = false;
        if (section === 'details') this.editDetails = false;
      },
      error: (err) => {
        this.alertService.error('Error', 'Error al actualizar prospecto');
        console.error(err);
      },
    });
  }


toggleSection(section: 'info' | 'details' | 'history') {
  if (section === 'info') {
    this.showInfoSection = !this.showInfoSection;
  } else if (section === 'details') {
    this.showDetailsSection = !this.showDetailsSection;
  } else if (section === 'history') {
    this.showHistorySection = !this.showHistorySection;
  }

}

getCurrentOrder(): number {
  const current = this.proStatus.find(
    (st: any) => st.id_estado === this.prospecto?.id_estado
  );
  return current ? current.orden : 0;
}

  openSendMail() {
    this.dialog.open(MdlSendMail, {
      minWidth: '750px',
      maxHeight: '700px',
      panelClass: 'mat-dlg-class',
      data: {
        mode: 'add', // o 'edit'
        mailData: { // Datos iniciales opcionales
          from: 'usuario@empresa.com',
          asunto: 'Asunto predefinido'
        },
        destinatarios: ['cliente@empresa.com'],
        tipo: 'individual'
      }
    });
  }
}
